
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component({
  name: 'ListNews',
})
export default class ListNews extends Vue {
  @Prop({ type: Array })
  readonly news: []
}
